import { Store } from '@ngxs/store';
import { GotoError, ShowErrorNotification } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { MSG_AUTOSTART_DEFAULT } from '../notification-messages';

export const showAutostartError = (store: Store, errorType: string, locale: string | null): Observable<unknown> =>
  store.dispatch([
    new ShowErrorNotification(MSG_AUTOSTART_DEFAULT),
    new GotoError({ queryParams: { errorType, lang: locale }, clearNotifications: false, autostartPage: true })
  ]);
